import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { WorkOrderRoleTitle } from "../../models";
import { RQ } from "../../globals/enums";
import { remove } from "../../api/generic-api";
import { deleteEntity } from "../../utils";

export const useDeleteWorkOrderRoleTitle = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("work-order-role-titles", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Work Order Role Title Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.WORK_ORDER_ROLE_TITLES,
        (workOrderRoleTitles: WorkOrderRoleTitle[] | undefined) => {
          return !workOrderRoleTitles
            ? []
            : deleteEntity<WorkOrderRoleTitle>(workOrderRoleTitles, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Work Order Role Title Deleting Error", {
        variant: "error",
      });
    },
  });
};
